export const YourGiftsStatusses = Object.freeze({
  trial: 'trial',
  active: 'active',
  inactiveLocked: 'inactiveLocked',
  locked: 'locked'
})

export const InformationBoxActions = Object.freeze({
  openPayment: 'openPayment',
  updatePayment: 'updatePayment',
  freeSocks: 'freeSocks',
  rejoin: 'rejoin',
  reactivation: 'reactivation',
  womenPrelaunch: 'womenPrelaunch',
  underShirtsLaunch: 'underShirtsLaunch'
})

export const InformationBoxTypes = Object.freeze({
  productPlusPackage: 'productPlusPackage',
  legacy: 'legacy',
  twoProductsVertical: 'twoProductsVertical',
  undershirtsReactivation: 'undershirtsReactivation',
  womenReactivation: 'womenReactivation',
  socksReactivation: 'socksReactivation',
  undershirtsSimple: 'undershirtsSimple',
  womenSimple: 'womenSimple',
  socksSimple: 'socksSimple'
})

export const InformationBoxReorderParams = Object.freeze({
  men: 'men',
  women: 'women',
  socks: 'socks',
  undershirts: 'undershirts'
})

export const InformationBoxButtonActions = Object.freeze({
  myRewards: 'myRewards',
  get20: 'get20',
  trialPeriod: 'trialPeriod',
  rejoinNow: 'rejoinNow'
})

export const NavVariant = Object.freeze({
  signup: 'signup',
  account: 'account',
  standard: 'standard',
  standardLoggedIn: 'standardLoggedIn'
})
